export default __webpack_public_path__ + "static/media/KAYO_artwork.c1fb2213.png";